import * as React from 'react';

import {FieldArray} from 'redux-form';

import {FormField} from 'shells/form/form-field';

import {AudienceSelect} from './audience-select';

type Props = {
    shouldAnd?: boolean;
};

export function AudienceForm(props: Props) {
    return (
        <FormField innerId='audiences' label='Which audience?'>
            <FieldArray name='audiences' component={AudienceSelect} shouldAnd={props.shouldAnd} />
        </FormField>
    );
}
